// tslint:disable

import * as _ from 'lodash';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { Validator, ValidatorResponse } from './Validators';

export class Field {
    public form: FormLib;
    public iri: string;
    public multi: boolean;
    public property: string;
    public required: boolean;
    public title: string;
    public registered = false;
    public value: any = null;
    public snapShotValue: any = null;
    public onValueChanges$: Subject<any> = new Subject();
    public onNEVERUSEONLYFORTHESPECIALHiddenValueChanges$: Subject<any> = new Subject();
    public onValidate$: Subject<any> = new Subject();
    public onError$: Subject<any> = new Subject();
    public onDisableChanges$: Subject<any> = new Subject();
    public validators: Validator[] = [];
    public isValid: boolean = false;
    public disabled: boolean = false;
    public placeholder: string = '';

    constructor(property: any) {
        this.iri = property.iri;
        this.multi = property.multi;
        this.property = property.property;
        this.required = property.required;
        this.title = property.title;
        this.placeholder = property.placeholder;
        this.onValidate$.subscribe(() => this.runValidators());
    }

    public removeValidators() {
        this.validators = [];
    }

    public async runValidators(): Promise<any> {
        const result = await Promise.all(this.validators.map(async (i: Validator) => {
            return await i(this);
        }));

        const errors = result.filter((i: ValidatorResponse) => !i.isValid);
        this.isValid = !errors.length;
        this.onError$.next(errors);
        return Promise.resolve(true);
    }

    public setValue(value: any, snapshot = false, emitEvent = true) {
        this.onNEVERUSEONLYFORTHESPECIALHiddenValueChanges$.next([value, snapshot, emitEvent]);
        this.value = value;
        if (snapshot) {
            this.snapShotValue = value;
        }
        if (emitEvent) {
            this.onValueChanges$.next(value);
        }

        /**
         * Run validators on all field without recursion
         * DO NOT TOUCH THIS :D
         */
        if (this.form && this.form.fields) {
            _.each(this.form.fields, (i: Field) => i.onValidate$.next());
        }
    }

    public getValue() {
        return this.value;
    }


    public setDisabled(value: boolean) {
        this.disabled = value;
        this.onDisableChanges$.next(value);
    }

    public registerField() {
        this.registered = true;
    }

    public addValidator(validator: Validator) {
        this.validators.push(validator);
    }
}

export class FormLib {
    public fields: any;
    public iri: string;
    public title: string;
    public operations: any;
    public onTriggerFetch$: Subject<boolean> = new Subject();
    public onValueChanges$: Subject<any> = new Subject();
    public onNEVERUSEONLYFORTHESPECIALHiddenValueChanges$: Subject<any> = new Subject();

    constructor(obj: any) {
        this.title = obj.title;
        this.iri = obj.iri;
        this.operations = obj.operations;
        this.fields = {};

        (obj.properties || []).forEach((property: any) => {
            this.fields[property.property] = new Field(property);
            this.fields[property.property].form = this;
            this.fields[property.property].onNEVERUSEONLYFORTHESPECIALHiddenValueChanges$.subscribe((...args: any[]) => this.onNEVERUSEONLYFORTHESPECIALHiddenValueChanges$.next(...args))
        });
    }

    public setFormValues(obj: any, snapshot = false) {
        _.each(obj, (value: any, property: string) => {
            this.setValue(property, value, false, snapshot);
        });
    }

    public setValue(key: string, value: any, emitEvent = true, snapshot = false) {
        if (this.fields && this.fields[key]) {
            this.fields[key].setValue(value, snapshot, emitEvent);
            this.fields[key].onValueChanges$.next(value);
            this.onValueChanges$.next(this.fields);
        }
    }

    public toJS(smart = false) {
        const R: any = {};
        _.each(this.fields, (i: Field) => {
            const provisoryProperty = i.value;

            if (smart) {
                if (i.registered && !this.isDeepEquals(provisoryProperty, i.snapShotValue)) {
                    R[i.property] = provisoryProperty;
                }
            } else {
                if (i.registered) {
                    R[i.property] = provisoryProperty;
                }
            }
        });

        return R;
    }

    public async validate() {
        for (let item in this.fields) {
            await this.fields[item].runValidators();
        }
    }

    public async isValid(): Promise<boolean> {
        await this.validate();

        const registeredFields = _.filter(this.fields, (i: Field) => i.registered);
        const invalidFields = _.filter(registeredFields, (i: Field) => !i.isValid);
        return Promise.resolve(!invalidFields.length);
    }

    public refetch() {
        this.onTriggerFetch$.next(true);
    }

    private isDeepEquals(a: any, b: any) {
        return JSON.stringify(a) === JSON.stringify(b);
    }
}



// WEBPACK FOOTER //
// ./src/components/libs/form.lib.ts